import icon1 from '../images/icon/database.png'
import icon2 from '../images/icon/lock.png'
import icon3 from '../images/icon/paymentt.png'
import icon4 from '../images/icon/timestaps.png'

const dataTechnology = [
    {
        icon: icon3,
        title: 'React Website',
        desc: 'JavaScript library for building user interfaces'
    },
    {
        icon: icon4,
        title: 'Web Graphics',
        desc: 'Code based and generated web visual'
    },
    {
        icon: icon1,
        title: 'Blockchain',
        desc: 'dApp develpment, NFTs, Meme Coins, DAOs, and Tokens'
    },
    {
        icon: icon2,
        title: 'Smart Contract',
        desc: 'Crypto based autonomous task based value transfer'
    },
]

export default dataTechnology;